// 3_pages/ordering_process_1.js
// Checkout step 1 (cart, body.id--9): reorganizes availability/delivery info, moves
// gifts and the cart summary, adds a coupon-field checkbox toggle, and relocates the
// sidebar based on viewport. Re-runs on cart content load and resize.

import {
	bindDeliveryTooltipInteractions,
	enhanceDeliveryTooltips,
} from "../2_components/delivery_tooltip.js";
import { storeSelectedGiftImage } from "./ordering_process_0_repeating.js";

export function init() {
	if (!document.body.classList.contains("id--9")) return;

	moveAvailabilityAmount();
	availabilityAndDeliveryWrapperCart();
	moveGiftsCart();
	moveCartSummaryToSidebar();
	addCheckboxToCouponField();
	giftSelectCustom();
	storeSelectedGiftImage();
	moveSidebarBasedOnMedia();
	enhanceCartItemDiscounts();

	document.addEventListener("ShoptetDOMCartContentLoaded", () => {
		moveAvailabilityAmount();
		availabilityAndDeliveryWrapperCart();
		moveGiftsCart();
		moveCartSummaryToSidebar();
		addCheckboxToCouponField();
		giftSelectCustom();
		storeSelectedGiftImage();
		moveSidebarBasedOnMedia();
		enhanceCartItemDiscounts();
	});

	document.addEventListener("ShoptetDOMContentLoaded", enhanceCartItemDiscounts);
	document.addEventListener("ShoptetCartUpdated", enhanceCartItemDiscounts);

	document.addEventListener("debouncedResize", function () {
		moveSidebarBasedOnMedia();
	});
}

function moveAvailabilityAmount() {
	const pAvailabilities = document.querySelectorAll(".cart-table .p-availability");
	if (!pAvailabilities || !pAvailabilities.length) return;

	pAvailabilities.forEach((pAvailability) => {
		const amount = pAvailability.querySelector(".availability-amount");
		if (!amount) return;

		const label = pAvailability.querySelector(".availability-label");
		if (!label) return;

		label.appendChild(amount);
	});
}

function availabilityAndDeliveryWrapperCart() {
	const pAvailabilities = document.querySelectorAll(".cart-table .p-availability");
	if (!pAvailabilities || !pAvailabilities.length) return;

	const deliveryTime = document.querySelector(".delivery-time");
	if (!deliveryTime) return;

	if (!deliveryTime.querySelector(".delivery-text-1")) {
		editDeliveryDateTextCart(deliveryTime);
	}

	pAvailabilities.forEach((pAvailability) => {
		if (pAvailability.querySelector(".availability-and-delivery-wrapper")) {
			return;
		}
		const availabilityAndDeliveryWrapper = document.createElement("div");
		availabilityAndDeliveryWrapper.classList.add("availability-and-delivery-wrapper");
		availabilityAndDeliveryWrapper.appendChild(deliveryTime.cloneNode(true));
		pAvailability.appendChild(availabilityAndDeliveryWrapper);
		enhanceDeliveryTooltips(availabilityAndDeliveryWrapper);
	});
	enhanceDeliveryTooltips(document);
	bindDeliveryTooltipInteractions();
}
function editDeliveryDateTextCart(deliveryTime) {
	const deliveryText1 = document.createElement("span");
	deliveryText1.classList.add("delivery-text-1");
	deliveryText1.textContent = window.NAT.translations("deliveryTime_1") + " ";

	const deliveryText2 = document.createElement("span");
	deliveryText2.classList.add("delivery-text-2");
	deliveryText2.textContent = " " + window.NAT.translations("deliveryTime_2");

	deliveryTime.prepend(deliveryText1);
	deliveryTime.appendChild(deliveryText2);
}

function moveGiftsCart() {
	const gifts = document.querySelector(".free-gift");
	const cartWrapper = document.querySelector("#cart-wrapper");
	if (gifts && cartWrapper) {
		cartWrapper.append(gifts);
	}
	const extraGift = document.querySelector(".extra.gift");
	if (extraGift && cartWrapper && !gifts) {
		const extraGiftWrapper = document.createElement("div");
		extraGiftWrapper.classList.add("free-gifts-wrapper");

		const extraGiftContainer = document.createElement("div");
		extraGiftContainer.classList.add("free-gift");
		extraGiftWrapper.appendChild(extraGift);

		extraGiftContainer.appendChild(extraGiftWrapper);
		cartWrapper.append(extraGiftContainer);
	}

	const freeGiftsWrapper = document.querySelector(".free-gifts-wrapper");
	if (freeGiftsWrapper) {
		const giftsHeader = document.createElement("h2");
		giftsHeader.classList.add("free-gifts-header");
		giftsHeader.textContent = window.NAT.translations("freeGiftsHeader");
		freeGiftsWrapper.prepend(giftsHeader);

		const freeGiftsImg = document.querySelectorAll(".free-gifts-img"); //for gift detection

		if (extraGift && freeGiftsImg && freeGiftsImg.length > 0) {
			giftsHeader.insertAdjacentElement("afterend", extraGift);

			const giftSpan = document.querySelector(".extra.gift > span");

			if (giftSpan) {
				const darkyPrice = document.querySelector(".extra.gift > span > strong").textContent;

				giftSpan.innerHTML =
					window.NAT.translations("darkyTextObjednejte") +
					"<strong>" +
					darkyPrice +
					"</strong>" +
					window.NAT.translations("darkyTextHodnotnejsi");
			}
		}

		if (freeGiftsImg && freeGiftsImg.length == 1) {
			const freeGiftsLabel = document.querySelector(".free-gift-label");

			const customFrom = document.createElement("form");
			const customUl = document.createElement("ul");
			customUl.classList.add("free-gifts");
			const customLi = document.createElement("li");
			customLi.classList.add("active");
			const customLabel = document.createElement("label");

			freeGiftsWrapper.appendChild(customFrom);
			customFrom.appendChild(customUl);
			customUl.appendChild(customLi);
			customLi.appendChild(customLabel);
			customLabel.appendChild(freeGiftsImg[0]);
			if (freeGiftsLabel) {
				customLabel.appendChild(freeGiftsLabel);
			}
		}
	}
}

function giftSelectCustom() {
	document.querySelectorAll(".free-gifts-wrapper .free-gifts label").forEach((label) => {
		label.addEventListener("click", function (event) {
			event.preventDefault();
			const forId = label.getAttribute("for");
			document.querySelectorAll(".free-gifts input").forEach((input) => {
				input.checked = input.id === forId;
			});
			const form = document.querySelector(".free-gifts-wrapper form");
			if (form && window.shoptet && shoptet.cart && typeof shoptet.cart.ajaxSubmitForm === "function") {
				shoptet.cart.ajaxSubmitForm(form.getAttribute("action"), form, "functionsForCart", "cart", true);
			}
			storeSelectedGiftImage();
		});
	});
}

function moveCartSummaryToSidebar() {
	const cartSummary = document.querySelector(".cart-summary");
	const sidebar = document.querySelector(".sidebar-in-cart");
	if (cartSummary && sidebar) {
		sidebar.append(cartSummary);
	}
}

function addCheckboxToCouponField() {
	const couponField = document.querySelector(".discount-coupon");
	if (!couponField) return;

	let checkbox = couponField.querySelector("#coupon-checkbox");
	if (!checkbox) {
		const checkboxWrapper = document.createElement("div");
		checkboxWrapper.classList.add("coupon-checkbox-wrapper");
		checkbox = document.createElement("input");
		checkbox.type = "checkbox";
		checkbox.id = "coupon-checkbox";
		checkbox.classList.add("coupon-checkbox-input");
		const label = document.createElement("label");
		label.htmlFor = "coupon-checkbox";
		label.classList.add("coupon-checkbox-label");
		label.textContent = window.NAT.translations("iHaveSaleCoupon");

		checkboxWrapper.appendChild(checkbox);
		checkboxWrapper.appendChild(label);
		couponField.prepend(checkboxWrapper);

		checkbox.addEventListener("change", function () {
			if (this.checked) {
				couponField.classList.remove("disabled");
			} else {
				couponField.classList.add("disabled");
			}
		});
	}

	const hasAppliedCoupon = Boolean(couponField.querySelector(".applied-coupon"));
	checkbox.checked = hasAppliedCoupon;
	if (hasAppliedCoupon || checkbox.checked) {
		couponField.classList.remove("disabled");
	} else {
		couponField.classList.add("disabled");
	}
}

function moveSidebarBasedOnMedia() {
	const sidebar = document.querySelector(".sidebar-in-cart");
	const cartRow = document.querySelector(".cart-row");
	const cartWrapper = document.querySelector("#cart-wrapper");
	if (!sidebar || !cartRow || !cartWrapper) return;
	if (window.NAT.media.isSmallTablet) {
		cartWrapper.appendChild(sidebar);
	} else {
		cartRow.appendChild(sidebar);
	}
}

function parseCartPrice(text) {
	if (!text) return NaN;
	const thou = window.shoptet?.config?.thousandSeparator ?? " ";
	const dec = window.shoptet?.config?.decSeparator ?? ",";
	let raw = String(text).replace(/[^\d.,\s\u00a0-]/g, "");
	if (thou) raw = raw.split(thou).join("");
	raw = raw.replace(/[\s\u00a0]/g, "");
	if (dec && dec !== ".") raw = raw.replace(dec, ".");
	return parseFloat(raw);
}

function formatCartPrice(value) {
	if (typeof value === "number" && typeof value.ShoptetFormatAsCurrency === "function") {
		return value.ShoptetFormatAsCurrency();
	}
	return String(value);
}

function disableCartPriceTooltip(tooltip) {
	const $el = window.jQuery?.(tooltip);
	if ($el?.data("bs.tooltip")) {
		$el.tooltip("destroy");
	}
	tooltip.removeAttribute("title");
	tooltip.classList.remove("show-tooltip");
}

function clearInjectedCouponColumns() {
	document.querySelectorAll(".cart-table tr.removeable .p-discount").forEach(function (discountCell) {
		if (discountCell.dataset.natCouponCol === "1") {
			discountCell.remove();
			return;
		}
		discountCell.querySelectorAll(".cart-coupon-percent").forEach(function (el) {
			el.remove();
		});
	});
}

function enhanceCartItemDiscounts() {
	clearInjectedCouponColumns();

	document.querySelectorAll(".cart-table tr.removeable").forEach(function (row) {
		const priceCell = row.querySelector(".p-price");
		const tooltip =
			priceCell?.querySelector('[data-testid="cartItemDiscount"]') ||
			priceCell?.querySelector(".show-tooltip.acronym");
		const priceFinal = priceCell?.querySelector(".price-final");
		row.querySelector(".p-total .cart-item-discount")?.remove();
		if (!tooltip || !priceCell || !priceFinal) {
			priceCell?.querySelector(".cart-item-discount")?.remove();
			return;
		}

		const tooltipText = tooltip.getAttribute("data-original-title") || tooltip.getAttribute("title") || "";
		disableCartPriceTooltip(tooltip);
		const percentMatch = tooltipText.match(/(\d+(?:[.,]\d+)?)\s*%/);
		const withoutPercent = tooltipText.replace(/(\d+(?:[.,]\d+)?)\s*%/g, "");
		const originalUnitMatch = withoutPercent.match(/(\d[\d\s\u00a0.,]*)/);
		const originalUnit = originalUnitMatch ? parseCartPrice(originalUnitMatch[1]) : NaN;
		const currentUnit = parseCartPrice(priceFinal.textContent);
		if (!percentMatch || !Number.isFinite(originalUnit) || originalUnit <= 0 || !Number.isFinite(currentUnit)) {
			priceCell.querySelector(".cart-item-discount")?.remove();
			return;
		}

		if (originalUnit <= currentUnit) {
			priceCell.querySelector(".cart-item-discount")?.remove();
			return;
		}

		const percent = Math.round(parseCartPrice(percentMatch[1]));
		let priceWrap = priceCell.querySelector(".cart-item-price-wrap");
		if (!priceWrap) {
			const priceGroup = priceFinal.closest('[data-testid="cartItemDiscount"]') || priceFinal.closest(".acronym") || priceFinal;
			const unitValue = priceCell.querySelector(".unit-value");
			priceWrap = document.createElement("span");
			priceWrap.className = "cart-item-price-wrap";
			priceGroup.after(priceWrap);
			priceWrap.append(priceGroup);
			if (unitValue) priceWrap.append(unitValue);
		}
		let discountRow = priceCell.querySelector(".cart-item-discount");
		if (!discountRow) {
			discountRow = document.createElement("span");
			discountRow.className = "cart-item-discount";
			const originalEl = document.createElement("span");
			originalEl.className = "cart-item-discount__original";
			const percentEl = document.createElement("span");
			percentEl.className = "cart-item-discount__percent";
			discountRow.append(originalEl, percentEl);
			priceWrap.before(discountRow);
		} else if (!discountRow.querySelector(".cart-item-discount__percent")) {
			const percentEl = document.createElement("span");
			percentEl.className = "cart-item-discount__percent";
			discountRow.append(percentEl);
		}
		discountRow.querySelector(".cart-item-discount__original").textContent = formatCartPrice(originalUnit);
		discountRow.querySelector(".cart-item-discount__percent").textContent = "-" + percent + "%";
	});
}
